/**
 * Layout para todas las rutas /admin/*. Hace el guard de rol UNA vez en
 * `beforeLoad` y delega el render a sus hijos vía Outlet. Si un usuario
 * sin rol admin tipea `/admin`, `/admin/users`, etc., se redirige a `/`.
 *
 * Defensa en profundidad — el API ya rechaza con 403 cualquier endpoint
 * sensible. Este guard evita renderizar la UI y disparar requests vanos.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { requireRoleGuard } from "@/lib/guards";

export const Route = createFileRoute("/admin")({
  beforeLoad: async ({ context }) => {
    await requireRoleGuard(context.queryClient, ["admin"]);
  },
  component: () => <Outlet />,
});
